import styled from 'styled-components';

export const Container = styled.div`
    color: #fff;
    position: absolute;
    opacity: 0.5;
`;
